import { Component } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent  {

  environment_termsOfPurchaseUrl: string = environment.termsOfPurchaseUrl;
}
